import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "auth-overlay"
}
const _hoisted_2 = {
  class: "auth-card",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_3 = { class: "auth-head" }
const _hoisted_4 = { class: "auth-tabs" }
const _hoisted_5 = { class: "captcha-row" }
const _hoisted_6 = { class: "captcha-row" }
const _hoisted_7 = ["src"]

import { computed, onBeforeUnmount, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { IconClose, IconLock, IconSafe, IconUser } from "@arco-design/web-vue/es/icon";
import { getEmailCodeCaptcha, registerByEmail, sendRegistrationEmailCode, userLoginUsingPost } from "@/api/userController";
import { useLoginUserStore } from "@/store/userStore";
import { useAuthModal } from "@/composables/useAuthModal";
import message from "@arco-design/web-vue/es/message";


export default /*@__PURE__*/_defineComponent({
  __name: 'AuthModal',
  setup(__props) {

const router = useRouter();
const { open, mode, returnTo, close, setMode } = useAuthModal();
const loginUserStore = useLoginUserStore();
const submitting = ref(false);
const sending = ref(false);
const countdown = ref(0);
const captchaCode = ref("");
const captchaImage = ref("");
const loginForm = ref({ userAccount: "", userPassword: "" });
const regForm = ref({ email: "", userPassword: "", checkPassword: "", emailCode: "" });
const openPasswordReset = () => { close(); router.push("/user/login?reset=1"); };
let timer: number | undefined;

const loadCaptcha = async () => {
  captchaCode.value = "";
  try {
    const r = await getEmailCodeCaptcha();
    if (r.data.code === 0) captchaImage.value = String(r.data.data || "");
  } catch {
    message.error("图形验证码加载失败");
  }
};

watch(mode, () => {
  loginForm.value = { userAccount: "", userPassword: "" };
  regForm.value = { email: "", userPassword: "", checkPassword: "", emailCode: "" };
  if (mode.value === "register") loadCaptcha();
}, { immediate: true });

const sendCode = async () => {
  if (!regForm.value.email) return message.warning("请先输入邮箱");
  if (!captchaCode.value || captchaCode.value.trim().length !== 4)
    return message.warning("请输入 4 位图形验证码");
  const captcha = captchaCode.value.trim();
  sending.value = true;
  try {
    const r = await sendRegistrationEmailCode(regForm.value.email, captcha);
    if (r.data.code !== 0) throw new Error(r.data.message);
    message.success("验证码已发送");
    countdown.value = 60;
    loadCaptcha();
    timer = window.setInterval(() => {
      countdown.value--;
      if (countdown.value <= 0 && timer) window.clearInterval(timer);
    }, 1000);
  } catch (e: any) {
    message.error(e?.response?.data?.message || e?.message || "发送失败");
    loadCaptcha();
  } finally {
    sending.value = false;
  }
};

const submitLogin = async () => {
  if (!loginForm.value.userAccount || !loginForm.value.userPassword)
    return message.error("请输入账号和密码");
  submitting.value = true;
  try {
    const res = await userLoginUsingPost(loginForm.value);
    if (res.data.code === 0) {
      await loginUserStore.fetchLoginUser();
      message.success("登录成功");
      close();
      router.push(returnTo.value);
    } else {
      message.error(res.data.message);
    }
  } catch {
    message.error("登录失败，请重试");
  } finally {
    submitting.value = false;
  }
};

const submitRegister = async () => {
  const f = regForm.value;
  if (!f.email || !f.userPassword || !f.checkPassword || !f.emailCode)
    return message.error("请填写完整信息");
  if (f.userPassword !== f.checkPassword) return message.error("两次密码不一致");
  submitting.value = true;
  try {
    const res = await registerByEmail(f);
    if (res.data.code === 0) {
      try {
        const login = await userLoginUsingPost({ userAccount: f.email, userPassword: f.userPassword });
        if (login.data.code !== 0) throw new Error(login.data.message);
        await loginUserStore.fetchLoginUser();
        message.success("注册并登录成功");
        close();
        router.push(returnTo.value);
      } catch {
        message.warning("账户已创建，请登录");
        setMode("login");
        loginForm.value.userAccount = f.email;
      }
    } else {
      message.error(res.data.message || "注册失败");
    }
  } catch {
    message.error("注册失败");
  } finally {
    submitting.value = false;
  }
};

onBeforeUnmount(() => {
  if (timer) window.clearInterval(timer);
});

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_unref(open))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("section", _hoisted_2, [
            _createElementVNode("header", _hoisted_3, [
              _createElementVNode("div", null, [
                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "auth-brand" }, "KomeiC", -1)),
                _createElementVNode("h2", null, _toDisplayString(_unref(mode) === "login" ? "欢迎回来" : "创建账号"), 1)
              ]),
              _createElementVNode("button", {
                class: "auth-close",
                type: "button",
                "aria-label": "关闭",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(close) && _unref(close)(...args)))
              }, [
                _createVNode(_unref(IconClose))
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({ on: _unref(mode) === 'login' }),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setMode)('login')))
              }, " 登录 ", 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass({ on: _unref(mode) === 'register' }),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setMode)('register')))
              }, " 注册 ", 2)
            ]),
            (_unref(mode) === 'login')
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "auth-form",
                  onSubmit: _withModifiers(submitLogin, ["prevent"])
                }, [
                  _createElementVNode("label", null, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", null, "账号或邮箱", -1)),
                    _createVNode(_component_a_input, {
                      modelValue: loginForm.value.userAccount,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((loginForm.value.userAccount) = $event)),
                      placeholder: "邮箱或用户名",
                      autocomplete: "username",
                      size: "large"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_unref(IconUser))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("span", null, "密码", -1)),
                    _createVNode(_component_a_input_password, {
                      modelValue: loginForm.value.userPassword,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((loginForm.value.userPassword) = $event)),
                      placeholder: "请输入密码",
                      autocomplete: "current-password",
                      size: "large"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_unref(IconLock))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("button", {
                    class: "forgot-link",
                    type: "button",
                    onClick: openPasswordReset
                  }, "忘记密码？"),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    long: "",
                    loading: submitting.value,
                    class: "auth-submit"
                  }, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode(" 登录 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ], 32))
              : (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  class: "auth-form",
                  onSubmit: _withModifiers(submitRegister, ["prevent"])
                }, [
                  _createElementVNode("label", null, [
                    _cache[14] || (_cache[14] = _createElementVNode("span", null, "邮箱", -1)),
                    _createVNode(_component_a_input, {
                      modelValue: regForm.value.email,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((regForm.value.email) = $event)),
                      placeholder: "name@example.com",
                      autocomplete: "email",
                      size: "large"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_unref(IconUser))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[15] || (_cache[15] = _createElementVNode("span", null, "设置密码", -1)),
                    _createVNode(_component_a_input_password, {
                      modelValue: regForm.value.userPassword,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((regForm.value.userPassword) = $event)),
                      placeholder: "8 位以上",
                      autocomplete: "new-password",
                      size: "large"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_unref(IconLock))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "确认密码", -1)),
                    _createVNode(_component_a_input_password, {
                      modelValue: regForm.value.checkPassword,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((regForm.value.checkPassword) = $event)),
                      placeholder: "请再次输入",
                      autocomplete: "new-password",
                      size: "large"
                    }, {
                      prefix: _withCtx(() => [
                        _createVNode(_unref(IconSafe))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "邮箱验证码", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_input, {
                        modelValue: regForm.value.emailCode,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((regForm.value.emailCode) = $event)),
                        placeholder: "4 位验证码",
                        "max-length": 4,
                        autocomplete: "one-time-code",
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_a_button, {
                        class: "code-button",
                        disabled: countdown.value > 0,
                        loading: sending.value,
                        onClick: _withModifiers(sendCode, ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(countdown.value > 0 ? `${countdown.value} 秒后重发` : "发送验证码"), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ])
                  ]),
                  _createElementVNode("label", null, [
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "图形验证码", -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_input, {
                        modelValue: captchaCode.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((captchaCode).value = $event)),
                        placeholder: "4 位字符",
                        "max-length": 4,
                        autocomplete: "off",
                        size: "large"
                      }, null, 8, ["modelValue"]),
                      (captchaImage.value)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: captchaImage.value,
                            alt: "图形验证码，点击可刷新",
                            class: "captcha-thumb",
                            title: "点击刷新",
                            onClick: loadCaptcha
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode(_component_a_button, {
                    type: "primary",
                    "html-type": "submit",
                    long: "",
                    loading: submitting.value,
                    class: "auth-submit"
                  }, {
                    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                      _createTextVNode(" 立即注册 ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["loading"])
                ], 32))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})